import * as React from 'react';
import { Col, Row, Button, Carousel, Modal } from 'antd';
import { observer } from 'mobx-react';
import { observable } from "mobx";
import autobind from "autobind-decorator";

import { ObjectUtils } from 'src/core/utils/object';
import { CommandBar } from 'src/core/ui/command-bar';
import { TextView } from 'src/core/ui/text.view';
import { VisibilityEditorView } from 'src/app/shared/parts/visibility-editor.view';

interface ImageGalleryViewProps {
	model: ImageGallery[];
	mode: ControlMode;
	onImageChange: (ev: React.ChangeEvent<HTMLInputElement>, size: number) => void;
	handleImageDelete: (image: ImageGallery) => void;
	saveImage: (title: string, visibility: VisibilityItem) => Promise<void>
	onCancel: () => void
    imageAdd: string;
    hideEdit?: boolean;
}

@observer
export class ImageGalleryView extends React.Component<ImageGalleryViewProps, {}> {
	@observable
	showDialog: boolean;
	//@observable
	fileName: string;
	visibility: VisibilityItem = {client:[],agent:[],supplier:[]};
	@autobind
	private closeDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
		ev.preventDefault();
		this.fileName = "";
		this.visibility = { client: [], agent: [], supplier: [] };
		this.props.onCancel();
		this.showDialog = false;
	}

	@autobind
	private acceptOption(ev?: React.MouseEvent<HTMLButtonElement>) {
		ev.preventDefault();
		this.props.saveImage(this.fileName, this.visibility);
		this.closeDialog(ev);
	}
// public render() {
// 		const { model, hideEdit } = this.props;
// 		if (model == null) {
// 			return null;
// 		}

// 		const addImageLabel=<label htmlFor="loadImage" className={`label-image text-center`}>
// 			Add images
// 			<input
// 				id="loadImage"
// 				disabled={this.props.mode == 'display'}
// 				type="file"
// 				style={{ display: 'none' }}
// 				accept="image/*"
// 				onChange={(ev) => {
// 					this.props.onImageChange(ev, 1024 * 1024);
// 				}}
// 			/>
// 		</label>

// 		if(!hideEdit){
// 			return (
// 				<div className="card p-3 card-borderless">
// 					<Row gutter={16}>
// 						<Col xs={24} lg={24}>
// 							{addImageLabel}
// 							{this.renderImages(model)}
// 						</Col>
// 					</Row>
// 				</div>
// 			);
// 		}
// 		else{
// 			return (
// 				<Row gutter={16}>
// 					<Col xs={24} lg={24}>
// 						{this.renderImages(model)}
// 					</Col>
// 				</Row>
// 			);
// 		}
// 	}
	public render() {
		const { model, hideEdit } = this.props;
		if (model == null) {
			return null;
		}
		return (
			<div className="card p-3 card-borderless">
				<Modal
					title="Add Images"
					wrapClassName="vertical-center-modal"
					visible={this.showDialog}
					maskClosable={false}
					onCancel={this.closeDialog}
					footer={[
						<Button key="Ok" type="primary" onClick={this.acceptOption}>Ok</Button>,
						<Button key="Cancel"  onClick={this.closeDialog}>Cancel</Button>,
					]}
				>
					<Row gutter={16}>
						<Col xs={24} lg={24}>
							<TextView
								mode={this.props.mode}
								label="File Name"
								value={this.fileName}
								onChanged={(newValue) => {
									this.fileName = newValue;
								}}
							/>
						</Col>
						<Col xs={24} lg={24}>
							<VisibilityEditorView
								disabled={this.props.mode == 'display' ? true : false}
								label="Visibility:"
								model={this.visibility}
							/>
						</Col>
						<Col xs={24} lg={24}>
							<label htmlFor="loadImage" className={`label-image text-center`}>
								Upload image
							{this.props.imageAdd &&<img src={'data:image/png;base64,' + this.props.imageAdd} style={{ width: "100%" }} alt="Select an image" />}
							<input
									id="loadImage"
									disabled={this.props.mode == 'display'}
									type="file"
									style={{ display: 'none' }}
									accept="image/*"
									onChange={(ev) => {
										this.props.onImageChange(ev, 1024 * 1024);
									}}
								/>
							</label>
						</Col>
					</Row>

				</Modal >
				<Row gutter={16}>
					<Col xs={24} lg={24}>
						{!hideEdit && <Button key="AddImage" type="primary" disabled={this.props.mode == 'display'} onClick={(ev) => this.showDialog = true}>Add Image</Button>}
						{this.renderImages(model)}

					</Col>
				</Row>
			</div>
		);
	}


	private renderImages(images: ImageGallery[]): JSX.Element {
		const { mode, handleImageDelete } = this.props;
		const imagesView: JSX.Element[] = [];

		for (const image of images) {
			let name = image.title && image.title.trim() != "" ? image.title:image.name
			imagesView.push(
				<div key={image.id}>
					<h3>
						<Row gutter={16}>
							{!this.props.hideEdit?(<Col xs={12} lg={12}>
								<CommandBar
									mode={mode}
									items={
										[
											{
												key: "name",
												itemType: 2,
												name: name,
											},
											{
												key: "delete",
												name: "Delete",
												icon: "delete",
												onClick: () => {
													const index = images.findIndex(i => i.id == image.id);
													if (index != -1) {
														handleImageDelete(image)
													}
												},
												type: "danger",
											}

										]
									}
								/>
							</Col>): null}
							<Col xs={12} lg={12}>
								{image.visibility && (image.visibility.agent.length > 0 || image.visibility.client.length > 0 || image.visibility.supplier.length > 0) &&<VisibilityEditorView
									disabled={true}
									label={null}
									model={image.visibility}
								/>}
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} lg={24}>
								<img
									src={'data:image/png;base64,' + image.content}
									className="image-gallery-item"
								/>
							</Col>
						</Row>

					</h3>
				</div>
			);
		}
		if (imagesView.length == 1) {
			return imagesView[0];
		}
		if(imagesView.length==0)
			return (
				<div style={{fontWeight:"bold"}}>
					No images to display
				</div>
			)
		return (
			<Carousel autoplay={true} adaptiveHeight={true}>
				{imagesView}
			</Carousel>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/image-gallery/image-gallery.view.tsx